class ArxBest extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    if (!this.track) return;

    this.prev = this.querySelector('.arx-best__arrow--prev');
    this.next = this.querySelector('.arx-best__arrow--next');
    this.timer = null;
    this.interval = Number(this.dataset.autoplayInterval || 5000);
    this.mobileAutoplay = this.dataset.mobileAutoplay !== 'false';
    this.mobileMq = window.matchMedia('(max-width: 749px)');
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.prev?.addEventListener('click', () => this.scrollBy(-1));
    this.next?.addEventListener('click', () => this.scrollBy(1));
    this.track.addEventListener('scroll', () => this.sync(), { passive: true });
    window.addEventListener('resize', () => {
      this.sync();
      this.syncAutoplay();
    }, { passive: true });

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.syncAutoplay());
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => this.syncAutoplay());

    this.mobileMq.addEventListener?.('change', () => this.syncAutoplay());

    this.sync();
    this.syncAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  isMobile() {
    return this.mobileMq.matches;
  }

  getStep() {
    const card = this.track.querySelector('.arx-card');
    if (!card) return 0;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 18;
    return card.getBoundingClientRect().width + gap;
  }

  /** @param {number} direction */
  scrollBy(direction) {
    const step = this.getStep();
    if (!step) return;

    if (this.isMobile()) {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth - 2);
      const atEnd = this.track.scrollLeft >= max;
      if (direction > 0 && atEnd) {
        this.track.scrollTo({ left: 0, behavior: this.reduced ? 'auto' : 'smooth' });
        return;
      }
      this.track.scrollBy({ left: step * direction, behavior: this.reduced ? 'auto' : 'smooth' });
      return;
    }

    const card = this.track.querySelector('.arx-card');
    if (!card) return;

    const trackStyles = getComputedStyle(this.track);
    const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 18;
    const cardWidth = card.getBoundingClientRect().width;
    const visible = Math.max(1, Math.floor((this.track.clientWidth + gap) / (cardWidth + gap)));
    const amount = visible * (cardWidth + gap);

    this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }

  scrollNextAuto() {
    this.scrollBy(1);
  }

  syncAutoplay() {
    if (window.Shopify && window.Shopify.designMode) {
      this.stopAutoplay();
      return;
    }
    if (
      this.isMobile() &&
      this.mobileAutoplay &&
      !this.reduced &&
      this.track.scrollWidth > this.track.clientWidth + 2
    ) {
      this.startAutoplay();
    } else {
      this.stopAutoplay();
    }
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = window.setInterval(() => this.scrollNextAuto(), this.interval);
  }

  stopAutoplay() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }

  sync() {
    if (!this.track) return;
    const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth - 2);
    if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
    if (this.next) this.next.disabled = this.track.scrollLeft >= max;
  }
}

if (!customElements.get('arx-best')) {
  customElements.define('arx-best', ArxBest);
}
